export default __webpack_public_path__ + "static/media/ic_tlp1_40.d003755c.svg";